module.exports = __webpack_public_path__ + "3dart-405ca811.webp";